import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../views/Home";
import SolicitudInformacionCrear from "../views/SolicitudInformacionCrear";
import SolicitudInformacionModificar from "../views/SolicitudInformacionModificar";
import SolicitudInformacionVisualizar from "../views/SolicitudInformacionVisualizar";
import PresentarRespuesta from "../views/PresentarRespuesta";
import ModificarRespuesta from "../views/ModificarRespuesta";
import Healthcheck from "../views/Healthcheck";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/solicitud_informacion/crear',
    name: 'solicitud_informacion_crear',
    component: SolicitudInformacionCrear
  },
  {
    path: '/solicitud_informacion/modificar',
    name: 'solicitud_informacion_modificar',
    component: SolicitudInformacionModificar
  },
  {
    path: '/solicitud_informacion/visualizar',
    name: 'solicitud_informacion_visualiar',
    component: SolicitudInformacionVisualizar
  },
  {
    path: '/respuesta/modificar',
    name: 'solicitud_informacion_respuesta_modificar',
    component: ModificarRespuesta
  },
  {
    path: '/respuesta/presentar',
    name: 'solicitud_informacion_respuesta_presentar',
    component: PresentarRespuesta
  },
  {
    path: '/healthcheck',
    name: 'healthcheck',
    component: Healthcheck
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/403',
    name: 'view403',
    component: () => import('../views/view403.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
